<template>
  <section class="section">
    <transition name="show" mode="out-in">
      <div v-if="loading" key="loading" style="font-size: 2em; margin: 100px auto">
        <i class="fas fa-spinner loading-big"></i>
      </div>
      <div v-if="!loading && user" key="content" style="min-height: 600px">

        <UserDetail
          v-if="true"
          :change="'dados'"
          :customer="customer"
          :previousShows="previousShows"
          :nextShows="nextShows"
          :onlineShows="onlineShows"
        />
        <!-- PERFIL -->
        <!-- <div class="profile-content">
          <div class="profile-container" :class="{ active : toggleProfile }">
            <div class="profile-image">
              <img v-if="customer.picture" @load="imgLoaded = true" :src="`https://graph.facebook.com/${customer.picture}/picture?type=large`" :class="{ loaded : imgLoaded }"/>
              <i v-if="!customer.picture" class="fas fa-user"></i>
            </div>
            <div class="profile-details">
              <div>{{ customer.name }}</div>
              <div>{{ customer.login }}</div>
            </div>
            <i @click="toggleProfile = !toggleProfile" class="profile-toggle fas" :class="toggleProfile ? 'fa-angle-up' : 'fa-angle-down'"></i>
            <div class="profile-actions">
              <button @click="$router.push(`/usuario/alterar/dados`)" type="button" class="button-action">
                <i class="fas fa-pen"></i>
                <span>Meus dados</span>
              </button>
              <button v-if="!customer.picture" @click="$router.push(`/usuario/alterar/senha`)" type="button" class="button-action">
                <i class="fas fa-key"></i>
                <span>Nova senha</span>
              </button>
              <button @click="signOut" type="button" class="button-action">
                <i class="fas fa-sign-out-alt"></i>
                <span>Sair</span>
              </button>
            </div>
          </div>
        </div> -->
        <!-- CUPONS -->
        <!-- <div v-if="invitations.length > 0" class="list-container">
          <div class="list-title">Cupons de desconto</div>
          <div v-for="invitation in invitations" :key="invitation.id" class="list">
            <div class="calendar">
              <div class="time-date">
                <span>{{ getDay(invitation.date) }}</span>
                <span>{{ getMonthText(invitation.date) }}</span>
              </div>
              <div class="time-hour">
                <span>{{ getHours(invitation.date) }}h</span>
                <span>{{ getMinutes(invitation.date) }}m</span>
              </div>
            </div>
            <div class="data">
              <div class="main-data" v-show="invitation.type === 'percent' || invitation.type === 'value'"><strong>{{ invitation.type === 'percent' ? `${invitation.discount.toFixed(0)}%` : `R$ ${invitation.discount.toLocaleString('pt-br', { minimumFractionDigits: 2 })}` }} de desconto</strong></div>
              <div class="main-data" v-show="invitation.type === 'fixed'"><strong>{{`Ingresso por apenas R$ ${invitation.discount.toLocaleString('pt-br', { minimumFractionDigits: 2 })}` }}</strong></div>
              <div class="main-data">{{ invitation.show }}</div>
              <div class="detail-data">{{ `${invitation.duration}min | ${invitation.showType}` }}</div>
              <div class="detail-data">Desconto válido até {{ invitation.expiration }}</div>
            </div>
            <div class="actions">
              <button @click="$router.push(getUrlShow(invitation))" class="button-list">
                <i class="fas fa-ticket-alt"></i><span>Comprar</span>
              </button>
            </div>
          </div>
        </div> -->
        <!-- NENHUM EVENTO -->
        <!-- <div v-if="nextShows.length === 0 && previousShows.length === 0 && onlineShows.length === 0" class="no-shows">
          <i class="far fa-clipboard"></i>
          <div class="now-shows-text">Nenhum ingresso encontrado</div>
        </div>
        <div v-if="type" class="message-container"> -->
          <!-- INGRESSO PAGO -->
          <!-- <div v-if="type === 'paid'" class="ticket-paid">
            <i class="fas fa-check"></i>
            <div class="ticket-paid-text">
              <span>Transação realizada com sucesso!</span>
              <span>Clique no evento abaixo para ver os ingressos.</span>
            </div>
          </div> -->

          <!-- INGRESSO ONLINE -->
          <!-- <div v-if="type === 'online'" class="ticket-paid">
            <i class="fas fa-check"></i>
            <div class="ticket-paid-text">
              <span>Transação realizada com sucesso!</span>
              <span>
                Você irá receber um e-mail com a compra e o link para o evento.<br />
                Caso não tenha recebido o e-mail, consultar a caixa de spam.
              </span>
            </div>
          </div>
        </div> -->
        <!-- AGUARDANDO PAGAMENTO -->
        <!-- <div v-if="waitingShows.length > 0" class="list-container">
          <div class="list-title">Aguardando Pagamento</div> -->
          <!-- INGRESSO BOLETO PAGAR -->
          <!-- <div v-if="type === 'pay' || billetWaiting" class="ticket-pay" style="margin-bottom:10px;">
            <i class="fas fa-history"></i>
            <div class="ticket-pay-text">
              <span>Boleto gerado! Aguardando pagamento...</span>
              <span>Clique no evento abaixo para ver o boleto.</span>
              <span>Os ingressos pagos por boleto serão enviados automaticamente para o e-mail <b>{{user.login}}</b> em até 48 horas após o pagamento, e também estarão disponíveis nesta área.</span>
            </div>
          </div>-->
          <!-- INGRESSO PIX PAGAR -->
          <!-- <div v-if="type === 'pay_pix' || pixWaiting" class="ticket-pay" style="margin-bottom:10px;">
            <i class="fas fa-history"></i>
            <div class="ticket-pay-text">
              <span>PIX gerado! Você tem até 10 min para realizar o pagamento.</span>
              <span>Clique no evento abaixo para ver o QR-Code ou chave PIX.</span>
              <span>Os ingressos pagos por PIX serão enviados automaticamente para o e-mail <b>{{user.login}}</b> em até 10 minutos após o pagamento, e também estarão disponíveis nesta área.</span>
            </div>
          </div> -->

          <!-- <div v-for="(show, index) in waitingShows" :key="index" class="list">
            <div class="calendar">
              <div class="time-date">
                <span>{{ getDay(show.date) }}</span>
                <span>{{ getMonthText(show.date) }}</span>
              </div>
              <div class="time-hour">
                <span>{{ getHours(show.date) }}h</span>
                <span>{{ getMinutes(show.date) }}m</span>
              </div>
            </div>
            <div class="data">
              <div class="main-data">{{ show.name }}</div>
              <div class="detail-data">{{ `${show.duration}min | ${show.type}` }}</div>
            </div>
            <div class="actions">
              <a  v-if="show.paymentMethod !== 'pix'" :href="show.printUrl" target="_blank" class="button-list" style="text-align: center; text-decoration: none">
                <i class="fas fa-barcode"></i><span>Boleto</span>
              </a>
              <a v-else @click="selectedWaitingTickect = show" target="_blank" class="button-list" style="text-align: center; text-decoration: none">
                <font-awesome-icon icon="fa-brands fa-pix" style="margin-right: 5px" /><span>Pix</span>
              </a>
            </div>
          </div>
        </div> -->
        <!-- EVENTOS ONLINE -->
        <!-- <div v-if="onlineShows.length > 0" class="list-container">
          <div class="list-title">Eventos Online</div>
          <div v-for="show in onlineShows" :key="show.id" class="list">
            <div v-if="show.live" class="calendar">
              <div class="time-date">
                <span>{{ getDay(show.date) }}</span>
                <span>{{ getMonthText(show.date) }}</span>
              </div>
              <div class="time-hour">
                <span>{{ getHours(show.date) }}h</span>
                <span>{{ getMinutes(show.date) }}m</span>
              </div>
            </div>
            <div v-else class="calendar">
              <div class="time-date">
                <span>até</span>
              </div>
              <div class="time-hour">
                <span>{{ getDay(show.date) }}</span>
                <span>{{ getMonthText(show.date) }}</span>
              </div>
            </div>
            <div class="data">
              <div class="main-data">{{ show.name }}</div>
              <div class="detail-data">{{ `${show.duration}min | ${show.type}` }}</div>
            </div>
            <div class="actions">
              <button v-if="show.type !== 'Curso'" @click="$router.push(`/video/${show.id}`)" class="button-list">
                <i class="fas fa-film"></i><span>Assistir</span>
              </button>
              <button v-else @click="$router.push(`/usuario/ingresso/${show.id}`)" class="button-list">
                <i class="fas fa-link"></i><span>Link</span>
              </button>
            </div>
          </div>
        </div> -->
        <!-- PRÓXIMOS EVENTOS -->
        <!-- <div v-if="nextShows.length > 0" class="list-container">
          <div class="list-title">Próximos Eventos</div>
          <div v-for="show in nextShows" :key="show.id" class="list">
            <div class="calendar">
              <div class="time-date">
                <span>{{ getDay(show.date) }}</span>
                <span>{{ getMonthText(show.date) }}</span>
              </div>
              <div class="time-hour">
                <span>{{ getHours(show.date) }}h</span>
                <span>{{ getMinutes(show.date) }}m</span>
              </div>
            </div>
            <div class="data">
              <div class="main-data">{{ show.name }}</div>
              <div class="detail-data">{{ `${show.duration}min | ${show.type}` }}</div>
            </div>
            <div class="actions">
              <button @click="$router.push(`/usuario/ingresso/${show.id}`)" class="button-list">
                <i class="fas fa-ticket-alt"></i><span>Ingressos</span>
              </button>
            </div>
          </div>
        </div> -->
        <!-- EVENTOS ANTERIORES -->
        <!-- <div v-if="previousShows.length > 0" class="list-container">
          <div class="list-title">Eventos Anteriores</div>
          <div v-for="show in previousShows" :key="show.id" class="list">
            <div class="calendar">
              <div class="time-date">
                <span>{{ getDay(show.date) }}</span>
                <span>{{ getMonthText(show.date) }}</span>
              </div>
              <div class="time-hour">
                <span>{{ getHours(show.date) }}h</span>
                <span>{{ getMinutes(show.date) }}m</span>
              </div>
            </div>
            <div class="data">
              <div class="main-data">{{ show.name }}</div>
              <div class="detail-data">{{ `${show.duration}min | ${show.type}` }}</div>
            </div>
          </div>
        </div> -->
      </div>
    </transition>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import logger from '../../logger'
import { removeToken } from '../../util'
import UserDetail from './UserDetail.vue'
import { get, update } from '../api/customer'
// import { getNextShows, getPreviousShows, getWaitingShows, getOnlineShows } from '../api/showDate'

export default {
  name: 'user',
  components: { UserDetail },
  props: ['type'],
  data () {
    return {
      loading: true,
      customer: null,
      toggleProfile: false,
      change: null,
      nextShows: [],
      previousShows: [],
      selectedWaitingTickect: null,
      showDate: null,
      imgLoaded: false,
      waitingShows: [],
      onlineShows: [],
      pixWaiting: false,
      billetWaiting: false
    }
  },
  computed: {
    ...mapState(['user', 'invitations'])
  },
  watch: {
    async '$route' (value) {
      this.showDate = value.params['showDate'] || null
      this.change = value.params['change'] || null
      // Update customer
      if (!this.change) {
        try {
          this.customer = await get()
          this.toggleProfile = false
        } catch (error) {
          logger.error(error, this)
        }
      }
    }
  },
  async mounted () {
    document.body.style.backgroundColor = '#f2f2f2'
    try {
      if (!this.user) {
        this.$router.push('/')
        this.$store.commit('redirect', '/usuario')
        this.$store.commit('showLogin', true)
        return false
      }

      this.showDate = this.$route.params['showDate'] || null
      this.change = this.$route.params['alterar'] || null
      const results = await Promise.all([
        get()
        // getNextShows(),
        // getPreviousShows(),
        // getWaitingShows(),
        // getOnlineShows()
      ])
      this.customer = results[0]

      for (let i = 0; i < this.waitingShows.length; i++) {
        if (this.waitingShows[i].paymentMethod === 'pix') {
          this.pixWaiting = true
        } else if (this.waitingShows[i].paymentMethod === 'billet') {
          this.billetWaiting = true
        }
      }
    } catch (error) {
      logger.error(error, this)
    }
    this.loading = false
    // setTimeout(() => { this.loading = false }, 2000)
  },
  methods: {
    async changeDetails () {
      if (this.loading) return false
      this.loading = true
      try {
        this.error = []
        await update(this.name, this.email, this.phone, this.newsletter)
        this.$router.push('/usuario')
        this.$message.success('Alteração realizada com sucesso.', { duration: 3000 })
        // One Signal
        /*
        // CORDOVA
        if (process.env.CORDOVA_PLATFORM) {
          window.plugins.OneSignal.getPermissionSubscriptionState(async (status) => {
            if (status.subscriptionStatus.subscribed) {
              window.plugins.OneSignal.sendTags({
                real_name: this.name,
                first_name: this.name.split(' ')[0]
              })
              window.plugins.OneSignal.setEmail(this.email)
              window.plugins.OneSignal.setSubscription(this.newsletter)
            }
          })
        // WEB
        } else {
          const pushEnabled = window.OneSignal ? await window.OneSignal.isPushNotificationsEnabled() : null
          if (pushEnabled) {
            window.OneSignal.push(() => {
              window.OneSignal.sendTags({
                real_name: this.name,
                first_name: this.name.split(' ')[0]
              })
            })
            window.OneSignal.setEmail(this.email)
            window.OneSignal.setSubscription(this.newsletter)
          }
        }
        */
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else {
          logger.error(error, this)
        }
      }
      this.loading = false
    },
    signOut () {
      removeToken()
      this.$store.commit('user', null)
      this.$router.push('/')
    },
    getUrlShow (invitation) {
      const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
      const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnooooooooprrsssssttuuuuuuuuuwxyyzzz------'
      const p = new RegExp(a.split('').join('|'), 'g')
      const url = invitation.show.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, '-e-') // Replace & with 'and'
        // eslint-disable-next-line no-useless-escape
        .replace(/[^\w\-]+/g, '') // Remove all non-word characters
        .replace(/--+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text
      return `/${invitation.businessUrl}/evento/${invitation.showId}/${url}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";
body {
  background-color: #f2f2f2 !important;
}
.section {
  margin-top: $menu-height;
  margin: 0px;
  padding: 0px;
  // background: #000;
  // min-height: 100vh;
}
.profile-content {
  background-image: linear-gradient(to bottom right, #0071b3, #0098b3);
}

.profile-container {
  max-width: $max-width;
  padding: $padding-mobile;
  margin: $menu-height auto 20px;
  color: #ffffff;
  height: auto;
  max-height: 75px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  transition: max-height 0.5s;
  &.active {
    max-height: 500px;
    .profile-actions {
      visibility: visible;
      opacity: 1;
      max-height: 200px;
    }
  }
}

.profile-image {
  width: 80px;
  height: 80px;
  border: 4px solid #fff;
  border-radius: 50%;
  align-self: flex-start;
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: contain;
    opacity: 0;
    transform: scale(0);
    transition: opacity 0.5s, transform 0.2s;
    &.loaded {
      opacity: 1;
      transform: scale(1);
    }
  }
  i {
    width: 100%;
    text-align: center;
    color: #fff;
    font-size: 50px;
    line-height: 75px;
  }
}

.profile-details {
  flex: 1;
  align-self: flex-start;
  margin-left: 15px;
  margin-top: 10px;
  div:nth-child(1) {
    font-size: 1.2em;
    font-weight: 400;
  }
  div:nth-child(2) {
    font-size: 0.85em;
    font-weight: 300;
  }
}

.profile-toggle {
  align-self: flex-start;
  margin-top: 8px;
  margin-left: 25px;
  color: #ffffff;
  font-size: 1.6em;
  padding: 10px 10px;
  cursor: pointer;
}

.profile-actions {
  padding: 15px 0;
  width: 100%;
  height: auto;
  max-height: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  visibility: hidden;
  opacity: 0;
  transition: max-height 0.5s, visibility 0.5s, opacity 0.5s;
}

.button-action {
  height: 35px;
  padding: 0 15px;
  margin: 8px 10px;
  color: #ffffff;
  border: 2px solid #ffffff;
  border-radius: 100px;
  background-color: transparent;
  font-size: 0.9em;
  cursor: pointer;
  &:focus {
    outline: 0;
  }
  span {
    font-weight: 500;
  }
  i {
    margin-right: 7px;
  }
}

.list-container {
  max-width: $max-width;
  padding: $padding-mobile;
  margin: 0 auto;
}

.list-title {
  font-size: 1.4em;
  font-weight: 400;
  color: #555;
  margin-bottom: 5px;
}

.list {
  display: flex;
  align-items: center;
  padding: 8px 5px;

  &:nth-child(2n+1) {
    background-color: #e5e5e5;
  }

  .calendar {
    width: 70px;
    display: flex;
    align-items: center;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
    margin-right: 10px;
  }

  .time-date {
    width: 35px;
    height: 35px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
    border-radius: 5px 0 0 5px;
    span:nth-child(1) {
      font-size: 1em;
      font-weight: 400;
    }
    span:nth-child(2) {
      font-size: 0.6em;
      font-weight: 500;
    }
  }

  .time-hour {
    width: 35px;
    padding: 0 5px;
    font-size: 1em;
    font-weight: 500;
    color: $primary-color;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    span:nth-child(2) {
      text-align: center;
      font-size: 0.6em;
    }
  }

  .data {
    flex: 1;
  }

  .main-data {
    font-size: 1em;
    color: #555;
  }

  .detail-data {
    font-size: 0.85em;
    font-weight: 300;
    color: #999;
  }
}

.button-list {
  display: flex;
  align-items: center;
  color: $primary-color;
  border: 1px solid $primary-color;
  border-radius: 100px;
  box-shadow: 0 0 3px $primary-color;
  background-color: #fff;
  font-size: 0.9em;
  width: 35px;
  height: 35px;
  cursor: pointer;
  &:focus {
    outline: 0;
  }
  span {
    overflow: hidden;
    max-width: 0;
    opacity: 0;
    font-weight: 500;
    transition: max-width 0.3s, opacity 0.2s;
  }
  i {
    flex: 1;
  }
}

.no-shows {
  background-color: #f7f8f9;
  color: #66758c;
  border-radius: 5px;
  padding: 20px 25px;
  max-width: 250px;
  margin: 50px auto;
  text-align: center;
  font-size: 1rem;

  i {
    font-size: 3rem;
    margin-bottom: 20px;
  }
}

.message-container {
  max-width: $max-width;
  padding: $padding-mobile;
  margin: 0 auto;
}

.ticket-paid {
  display: flex;
  align-items: center;
  color: rgb(13, 94, 13);
  border: 1px solid rgb(13, 94, 13);
  border-radius: 5px;
  background-color: rgba(13, 94, 13, 0.1);
  padding: 10px;
  i {
    font-size: 2.2em;
    margin-right: 15px;
  }
  .ticket-paid-text {
    span:nth-child(1) {
      display: block;
      font-size: 1em;
      font-weight: 500;
    }
    span:nth-child(2) {
      display: block;
      font-size: 0.9em;
      margin-top: 2px;
    }
  }
}

.ticket-pay {
  display: flex;
  align-items: center;
  color: rgb(0, 113, 179);
  border: 1px solid rgb(0, 113, 179);
  border-radius: 5px;
  background-color: rgba(0, 113, 179, 0.1);
  padding: 10px;
  i {
    font-size: 2.2em;
    margin-right: 15px;
  }
  .ticket-pay-text {
    span:nth-child(1) {
      display: block;
      font-size: 1em;
      font-weight: 500;
    }
    span:nth-child(2) {
      display: block;
      font-size: 0.9em;
      margin-top: 2px;
    }
  }
}

// Desktop
@media screen and (min-width: $desktop-width) {
  .profile-container {
    padding: $padding-desktop;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .profile-toggle {
    display: none;
  }

  .profile-actions {
    width: auto;
    visibility: visible;
    opacity: 1;
    max-height: 200px;
    padding: 0;
    align-self: flex-start;
    margin-top: 3px;
  }

  .button-action:hover {
    i {
      margin-right: 7px;
      animation-name: ticket-save;
      animation-timing-function: ease-in-out;
      animation-duration: 0.8s;
      animation-iteration-count: 5;
    }
  }

  .list-container {
    padding: $padding-desktop;
  }

  .button-list {
    width: auto;
    padding: 0 15px;
    background-color: $hover-color-2;
    i {
      margin-right: 7px;
    }
    span {
      max-width: 100px;
      opacity: 1;
    }
    &:hover {
      i {
        animation-name: ticket-save;
        animation-timing-function: ease-in-out;
        animation-duration: 0.7s;
        animation-iteration-count: 5;
      }
    }
  }

  .message-container {
    padding: $padding-desktop;
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
</style>
